import { flagKeys } from './misc.constants';

export const PLATFORM_IDS = {
  WIX: 0,
  CUSTOM: 1,
  WORDPRESS: 2,
  KYVIO: 3,
  DRUPAL: 4,
  DRUPAL7: 5,
  DRUPAL8: 7,
  TYPO: 7,
  OCTOBER: 8,
  MAGENTO: 9,
  OPENCART: 10,
  WEEBLY: 11,
  WIX_MINI: 12,
};

export const is3ASUnlimitedFreeTrialPlan = (planName: string) => {
  return ['unlimited_30_day_free_trial', 'unlimited_free_trial'].includes(planName);
};

export enum PlanNames {
  Free = 'Free',
  Basic = 'Basic',
  Advanced = 'Advanced',
  Pro = 'Pro',
  ProPlus = 'Pro +',
  Custom = 'Custom',

  // Deleted plans; might still be found on subscriptions that were created before deletion
  ProPlusPlus = 'Pro ++',
  Executive = 'Executive',
  ExecutivePlus = 'Executive +',
  ExecutivePlusPlus = 'Executive ++',
  Unicorn = 'Unicorn',
}

export const DeletedPlans = [
  PlanNames.ProPlusPlus,
  PlanNames.Executive,
  PlanNames.ExecutivePlus,
  PlanNames.ExecutivePlusPlus,
  PlanNames.Unicorn,
];

export enum PlanIndexes {
  Free = -1,
  Starter = 0,
  Basic = 1,
  Advanced = 2,
  Pro = 3,
  ProPlus = 4,
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}

export enum TrackingCodeStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export enum ApiRequestStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export const POLLS_AND_SURVEYS_QUESTION_LIMIT = 65;
export const MAXIMUM_FUNNEL_LEVELS_COUNT = 14;

export const UPDATE_WEBSITES_EVENT = 'UPDATE_WEBSITES';

export const FRONTEND_FLAGS_ADDED_BEFORE_FIRST_LOGIN = [
  flagKeys.ONBOARDING_FINISHED,
  flagKeys.LAST_COMPLETED_ONBOARDING_STEP,
];

export const UNTRANSLATED_LOCALE = 'UNTR';

export const websiteCreationSteps = {
  choosePlatform: 0,
  websiteUrl: 1,
  privacyLevels: 2,
  loading: 3,
  trackingCodeInstallation: 4,
};

export const websiteFlagKeys = {
  CREATION_PROCESS_COMPLETED: 'creationCompleted',
  ACCEPTED_HEATMAP: 'acceptedHeatmap',
  RECORDINGS_SETTINGS: 'recordingsSettings',
  WELCOME_FUNNELS: 'welcomeFunnel',
  ONBOARDING_COMPLETED: 'onboardingCompleted',
  LAST_COMPLETED_ONBOARDING_STEP: 'lastCompletedOnboardingStep',
  LAST_SEEN_FREE_TRIAL_MODAL: 'lastSeenFreeTrialModal',
  DO_NOT_SHOW_BUSINESS_INFO_MODAL: 'doNotShowBusinessInfoModal',
  CONVERSIONS_ONBOARDING_COMPLETED: 'conversionsOnboardingCompleted',
  CONVERSIONS_BANNER_HIDDEN: 'hideConversionsBanner',
  CUSTOM_EVENTS_BANNER_HIDDEN: 'hideCustomEventsBanner',
  AI_ONBOARDING_COMPLETED: 'aiOnboardingCompleted',
  HAD_FIRST_LOGIN: 'hadFirstLogin',
  TREND_INTEL_FIRST_ENABLED_AT: 'trendIntelFirstEnabledAt',
  TREND_INTEL_ONBOARDING_COMPLETED: 'trendIntelOnboardingCompleted',
};

export const featureTourFlagKeys = {
  dashboard: 'dashboardTourCompleted',
};

export const defaultPrivacyLevel = [
  {
    levelKey: 0,
    selected: false,
    exceptions: [],
  },
  {
    levelKey: 1,
    selected: false,
    exceptions: [],
  },
  {
    levelKey: 2,
    selected: false,
    exceptions: [],
  },
  {
    levelKey: 3,
    selected: true,
    exceptions: [],
  },
];

export type SupportedCurrency = 'EUR' | 'USD' | 'GBP' | 'RON' | 'DKK' | 'PLN';

export type Currency = {
  code: SupportedCurrency;
  symbol?: string;
};

export const websiteCurrencies: Currency[] = [
  { code: 'EUR', symbol: '€' },
  { code: 'USD', symbol: '$' },
  { code: 'GBP', symbol: '£' },
  { code: 'DKK', symbol: 'kr.' },
  { code: 'PLN', symbol: 'zł' },
  { code: 'RON' },
];

export const currencySymbols: { [key in SupportedCurrency]: string } = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  DKK: 'kr.',
  PLN: 'zł',
  RON: '',
};
